"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9071],{

/***/ 25289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65832);
/* harmony import */ var constants_dynamic_asset_by_param__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93879);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54224);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_query_params__WEBPACK_IMPORTED_MODULE_2__);




/* harmony default export */ __webpack_exports__["Z"] = ({
    assetQuality: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Asset Quality",
        options: [
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.AUTO,
                text: "Auto"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.BEST,
                text: "Best"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.GOOD,
                text: "Good"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.ECO,
                text: "Eco"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.LOW,
                text: "Low"
            }
        ]
    },
    useDynamicAsset: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use dynamic asset (when available)"
    },
    dynamicAssetParamPath: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Use image from parameter",
        labelDescription: "Image (?".concat(_constants_query_params__WEBPACK_IMPORTED_MODULE_2__.DYNAMIC_ASSET_PARAM, "=xxxxx) from param will build Cloudinary url under the selected path below and replaces the default image."),
        options: constants_dynamic_asset_by_param__WEBPACK_IMPORTED_MODULE_1__/* .DYNAMIC_ASSET_PARAM_PATHS */ .Y
    },
    hideControls: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide controls (video only)"
    },
    useWindowMask: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use window mask"
    },
    minHeight: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Min height"
    }
});


/***/ }),

/***/ 2395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ERROR_GROUPS; }
/* harmony export */ });
var ERROR_GROUPS = {
    SEGMENT_LAYOUT: "segment_layout"
};


/***/ }),

/***/ 67998:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASE_MENU_WIDTH: 350,
    DEVELOPERS_MENU_WIDTH: 300
});


/***/ }),

/***/ 87292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ StyledDynamicTemplate; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var _constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);
/* harmony import */ var components_pages_developers_documentation_base_documentation_menu_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67998);



var GRID_COLUMNS_WIDTH = "".concat(components_pages_developers_documentation_base_documentation_menu_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DEVELOPERS_MENU_WIDTH */ .Z.DEVELOPERS_MENU_WIDTH, "px auto ").concat(components_pages_developers_documentation_base_documentation_menu_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DEVELOPERS_MENU_WIDTH */ .Z.DEVELOPERS_MENU_WIDTH, "px");
var StyledDynamicTemplate = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ephfv7d0"
})("&.developers-center-template{.full-paragraph-wrapper{margin:0 !important;}@media (min-width:", _constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){main{display:grid;grid-template-columns:", GRID_COLUMNS_WIDTH, ";}}}");


/***/ }),

/***/ 19563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ triangleHeightFactor; },
/* harmony export */   "u": function() { return /* binding */ StyledBaseLayoutSegmentComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var utils_math__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70942);
/* harmony import */ var constants_z_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35257);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12573);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73759);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__);






var triangleHeightFactor = Math.sin((0,utils_math__WEBPACK_IMPORTED_MODULE_3__/* .toRadians */ .Yr)(8));
var CARD_MARGIN = "16px";
var CARD_BORDER_RADIUS = "40px";
var getCardWidthStyle = function(cardWidth) {
    return "\n				width: calc(min(100%, ".concat(cardWidth, ") - (").concat(CARD_MARGIN, " * 2));\n				margin: 0 calc((100% - min(100%, ").concat(cardWidth, ")) / 2 + ").concat(CARD_MARGIN, ") ;\n");
};
var _obj;
var cardBorderToStyle = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.FULL, "border-radius: ".concat(CARD_BORDER_RADIUS, ";")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.TOP, "\n    border-top-right-radius: ".concat(CARD_BORDER_RADIUS, ";\n    border-top-left-radius: ").concat(CARD_BORDER_RADIUS, ";\n  ")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.BOTTOM, "\n    border-bottom-right-radius: ".concat(CARD_BORDER_RADIUS, ";\n    border-bottom-left-radius: ").concat(CARD_BORDER_RADIUS, ";\n  ")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.NONE, ""), _obj);
var StyledBaseLayoutSegmentComponent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1v1kdfp0"
})("&.ease-in{opacity:0;&.ease-in-animation{animation:fade-in 0.5s ease-in forwards;.segment-wrapper{animation:slide-in 0.8s ease-in;}}.segment-wrapper{transform:none;}}.segment-wrapper{transform:none;&.card{margin:0 ", CARD_MARGIN, ";", function(param) {
    var cardBorderStyle = param.cardBorderStyle;
    return cardBorderToStyle[cardBorderStyle || segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.FULL];
}, "            background-color:", function(param) {
    var cardBackgroundColor = param.cardBackgroundColor;
    return styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[cardBackgroundColor];
}, ";", function(param) {
    var cardWidth = param.cardWidth;
    return cardWidth ? getCardWidthStyle(cardWidth) : "";
}, "            padding:", function(param) {
    var cardPadding = param.cardPadding;
    return cardPadding;
}, ";position:relative;}.background-asset{width:100%;height:100%;top:0;left:0;position:absolute;.asset-inner{width:100%;height:100%;", function(param) {
    var cardBorderStyle = param.cardBorderStyle;
    return cardBorderToStyle[cardBorderStyle || segments_desktop_constants__WEBPACK_IMPORTED_MODULE_2__.CARD_BORDER_STYLE.FULL];
}, "                \n                .picture-component{width:100%;height:100%;.main-image{width:100%;height:100%;object-fit:cover;}}}}.full-paragraph-component{position:relative;}}&.sticky{position:sticky;top:", function(param) {
    var stickyTopOffset = param.stickyTopOffset;
    return stickyTopOffset || 0;
}, ";z-index:", constants_z_index__WEBPACK_IMPORTED_MODULE_5__/* .TOP_BAR */ .sE, ";}.triangle{position:absolute;z-index:2;pointer-events:none;&.top{width:0;height:0;border-right:100vw solid transparent;// the 0.05 addition solves a number rounding bug resulting in a 1px white line displayed\n            margin-top:-", 100 * triangleHeightFactor - 0.05, "vw;}&.bottom{width:0;height:0;border-left:100vw solid transparent;}}@keyframes fade-in{0%{opacity:0;}100%{opacity:1;}}@keyframes slide-in{0%{transform:translateY(40px);}100%{transform:translateY(0px);}}");


/***/ }),

/***/ 93879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DYNAMIC_ASSET_PARAM_PATHS; }
/* harmony export */ });
var YEAR_IN_REVIEW_2020 = "year-in-review/2020";
var DYNAMIC_ASSET_PARAM_PATHS = [
    {
        value: YEAR_IN_REVIEW_2020,
        text: "Year In Review 2020"
    }
];


/***/ }),

/***/ 42711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(861);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);




/* harmony default export */ __webpack_exports__["Z"] = ({
    gradientTheme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Override gradient theme color",
        maxLimit: 3,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            fields: {
                color: {
                    label: "Color",
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_1__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.MIDNIGHT_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.INDIGO_BLUE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.AMETHYST_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.SAPPHIRE_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.DEEP_NAVY_BLUE_COLOR
                    ])
                }
            }
        }
    }
});


/***/ }),

/***/ 95660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        position: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Position",
            options: [
                "left",
                "center",
                "right"
            ]
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-advanced-config.js
function regular_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_asset_advanced_config_object_spread_props(regular_asset_advanced_config_object_spread(regular_asset_advanced_config_object_spread_props(regular_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop (% only)"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile (% only)"
        }
    }), advanced_field_config/* default */.Z), {
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/index.js

var RegularAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(390), __webpack_require__.e(4961), __webpack_require__.e(8540)]).then(__webpack_require__.bind(__webpack_require__, 98181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98181)
            ];
        }
    }
});


/* harmony default export */ var regular_asset = ({
    RegularAssetComponent: RegularAssetComponent,
    RegularAssetConfig: regular_asset_config,
    RegularAssetAdvancedConfig: regular_asset_advanced_config
});


/***/ }),

/***/ 61204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Bullets",
    fields: {
        bulletTextSize: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Bullet text size",
            options: [
                {
                    value: "0.8125rem",
                    text: "13px"
                },
                {
                    value: "0.875rem",
                    text: "14px"
                },
                {
                    value: "1rem",
                    text: "16px"
                }
            ]
        },
        bulletsDirection: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Bullets direction",
            options: [
                {
                    value: "row",
                    text: "Row"
                },
                {
                    value: "column",
                    text: "Column"
                }
            ]
        },
        bulletsColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Bullets color"
        },
        checkColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Check color"
        },
        bullets: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Bullets",
            nestedConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                fields: {
                    bulletText: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Text",
                        translatable: true
                    },
                    href: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Href"
                    },
                    openInNewTab: {
                        type: "boolean",
                        label: "Should Open In New Tab"
                    }
                }
            }
        }
    }
});


/***/ }),

/***/ 33751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13225);


/* harmony default export */ __webpack_exports__["Z"] = ({
    autoplay: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Autoplay"
    },
    centerPadding: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Center padding (in center mode)"
    },
    pauseOnHover: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Pause on hover (if auto play is enabled)"
    },
    autoplaySpeed: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Autoplay speed (in miliseconds)"
    },
    infinite: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Slide inifinitely"
    },
    slidesToShow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Slides to show"
    },
    easing: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Animation ease function",
        options: [
            {
                value: "cubic",
                text: "Cubic"
            },
            {
                value: "linear",
                text: "Linear"
            },
            {
                value: "ease",
                text: "Ease"
            },
            {
                value: "ease-in",
                text: "Ease in"
            },
            {
                value: "ease-out",
                text: "Ease out"
            },
            {
                value: "ease-in-out",
                text: "Ease in out"
            }
        ]
    },
    defaultImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Default image",
        fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].image.fields */ .Z.image.fields
    },
    slides: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Slides",
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
            fields: {
                asset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                }
            }
        }
    }
});


/***/ }),

/***/ 55782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24586);


/* harmony default export */ __webpack_exports__["Z"] = ({
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    backgroundImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Background Image",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                getFullUrl: true
            },
            alt: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image description (Don't fill if image is a decorative image)",
                translatable: true
            }
        }
    }
});


/***/ }),

/***/ 47285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_title_advanced_field_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95760);
/* harmony import */ var segments_desktop_core_components_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50342);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var segments_core_configs_advanced_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42711);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_advanced_field_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, segments_desktop_core_components_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, segments_core_configs_advanced_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    topicBottomMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin between topic and paragraph (defaults: text - 16px | image - 40px)"
    },
    spaceFromParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin between title and text (px)"
    },
    buttonTopMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin above button (default 32px)"
    }
}));


/***/ }),

/***/ 78739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    src: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an Image"
    },
    alt: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Image description (alt)",
        translatable: true
    },
    isDecorative: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Decorative image(no alt)"
    },
    link: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image link",
        fields: {
            href: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image href"
            },
            isNewTab: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Open link in new tab"
            }
        }
    }
});


/***/ }),

/***/ 41667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_grid_image_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78739);
/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75650);
/* harmony import */ var segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64054);
/* harmony import */ var segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54237);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96587);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24586);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var restGridFields = _extends({}, _object_destructuring_empty(segments_desktop_core_components_grid_image_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));
/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, restGridFields), {
    showParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show paragraph"
    },
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: _object_spread_props(_object_spread({}, segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
            buttonConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
                label: "Button",
                conditionalKeyName: "buttonType",
                options: [
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .REGULAR_BUTTON_TYPE */ .ys,
                        fieldsConfig: segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
                    },
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .SECONDARY_BUTTON_TYPE */ .jE,
                        fieldsConfig: segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                    },
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .SIGNUP_BUTTON_TYPE */ .ge,
                        fieldsConfig: segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
                    }
                ]
            }
        })
    }
}));


/***/ }),

/***/ 50342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


/* harmony default export */ __webpack_exports__["Z"] = ({
    textSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM,
                text: "14px"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MS,
                text: "16px"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "18px (formerly 20px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "22px (formerly 24px)"
            }
        ]
    },
    textWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text width"
    },
    withDynamicParagraphTitle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dynamic paragraph Title"
    },
    withDynamicParagraphSubtitle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dynamic paragraph Subtitle"
    }
});


/***/ }),

/***/ 77374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93097);


var background = segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].background */ .Z.background;
/* harmony default export */ __webpack_exports__["Z"] = ({
    alignToLogo: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Align to logo (New)"
    },
    leftSizeWidth: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Override left side size"
    },
    rightSizeWidth: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Override right side size"
    },
    spaceBetweenTextAndAsset: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Horizontal space between 2 sides (desktop)"
    },
    mobileSpaceBetweenTextAndAsset: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Vertical space between 2 sides (tablet + mobile)"
    },
    background: background
});


/***/ }),

/***/ 93097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24586);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77869);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var image = components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].image */ .Z.image;
var src = image.fields.src;
var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    swapTextAndAssetPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swap Text And Asset Position - Desktop"
    },
    mobileSwapTextAndAssetPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swap Form and Texts position - Mobile"
    },
    hideParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide paragraph"
    },
    paragraphVerticalAlignment: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Paragraph Vertical Alignment",
        options: [
            "top",
            "center",
            "bottom"
        ]
    },
    alignImageToScreenEdge: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Align Image To Screen Edge"
    },
    background: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Background",
        fields: {
            width: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                label: "Width",
                options: [
                    "50%",
                    "75%",
                    "100%"
                ]
            },
            color: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Color",
                possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
            },
            verticalPadding: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Vertical Padding"
            },
            backgroundImage: _object_spread_props(_object_spread({}, image), {
                label: "Background image",
                fields: _object_spread_props(_object_spread({
                    backgroundPosition: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Background position",
                        options: [
                            "left",
                            "center",
                            "right"
                        ]
                    }
                }, image.fields), {
                    src: _object_spread_props(_object_spread({}, src), {
                        getFullUrl: true
                    })
                })
            })
        }
    },
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: selectedFullParagraphFields
    },
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.XL,
                text: "64px (formerly 72px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__/* .XXL */ .T3,
                text: "72px (formerly 80px)"
            }
        ]
    },
    asset: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Asset",
        fields: _object_spread({
            position: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                label: "Position",
                options: [
                    "top",
                    "center",
                    "bottom"
                ]
            },
            fitToContainer: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Fit to container"
            },
            assetHeight: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Height"
            }
        }, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)
    }
});


/***/ }),

/***/ 73498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    tagsWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Tags width (max 170px, min 140px)"
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup Button",
        fields: {
            removeGradient: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Remove gradient"
            }
        }
    },
    showBorderInLightTheme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Add tags border in white theme"
    },
    randomizeTags: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Randomize tags"
    }
});


/***/ }),

/***/ 22333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96587);
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var signupClusterId = segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].signupClusterId */ .Z.signupClusterId, restSignupButtonConfig = _object_without_properties(segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "signupClusterId"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme"
    },
    clusters: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Clusters",
        maxLimit: 9,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                text: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                image: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    label: "Image"
                },
                colorName: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                clusterId: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLUSTERS,
                    label: "Cluster Id"
                },
                useCaseId: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.SUB_CLUSTERS,
                    label: "Usecase Id"
                },
                initiallySelected: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Initially selected"
                }
            }
        }
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup button",
        fields: restSignupButtonConfig
    }
});


/***/ }),

/***/ 61543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13225);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65621);



/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    fields: {
        quote: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Text",
            fields: segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        },
        author: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Author Name"
        },
        company: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Author Company",
            fields: segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        },
        asset: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Author Picture",
            fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].image.fields */ .Z.image.fields
        },
        backgroundColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        }
    }
});


/***/ }),

/***/ 17702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59440);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65621);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    textAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    }
}, segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), {
    textColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Text Color",
        possibleColors: [
            "brand-blue",
            "brand-pink",
            "brand-iris",
            "brand-green",
            "brand-red",
            "brand-purple"
        ]
    },
    buttonConfig: segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
}));


/***/ }),

/***/ 95760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


/* harmony default export */ __webpack_exports__["Z"] = ({
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL,
                text: "64px (formerly 72px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3,
                text: "72px (formerly 80px)"
            }
        ]
    },
    titleMinWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Title min width"
    },
    titleWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Title max width"
    }
});


/***/ }),

/***/ 92607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93097);
/* harmony import */ var segments_desktop_core_components_title_only_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17702);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var background = segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].background */ .Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "background"
]);
var textColor = segments_desktop_core_components_title_only_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].textColor */ .Z.textColor, buttonConfig = segments_desktop_core_components_title_only_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].buttonConfig */ .Z.buttonConfig, textAlign = segments_desktop_core_components_title_only_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].textAlign */ .Z.textAlign, selectedTitleOnlyParagraphFields = _object_without_properties(segments_desktop_core_components_title_only_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, [
    "textColor",
    "buttonConfig",
    "textAlign"
]);
/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    title: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Title",
        fields: selectedTitleOnlyParagraphFields
    },
    backgroundColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Background color"
    },
    tabsColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Tabs color"
    },
    paddingAboveTabs: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Padding between title and tabs"
    },
    tabs: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 8,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                tabLabel: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                textAndAsset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Text and asset",
                    fields: selectedSideBySideTextAndAssetFieldsConfig
                }
            }
        }
    }
}));


/***/ }),

/***/ 74790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69223);
/* harmony import */ var components_core_asset_advanced_field_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25289);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread(_object_spread_props(_object_spread({}, segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP), {
    timerEnabled: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Timer enabled"
    },
    alwaysShowProgressbar: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Always show progress bar"
    },
    arrowSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Arrow size"
    },
    title: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Title",
        fields: {
            fontSize: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Font size"
            },
            lineHeight: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Line height"
            },
            selectedFontSize: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Selected font size"
            },
            fontColor: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Font color"
            },
            selectedFontColor: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Selected font color"
            }
        }
    }
}), components_core_asset_advanced_field_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ }),

/***/ 32983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59440);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13225);
/* harmony import */ var segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72898);




/* harmony default export */ __webpack_exports__["Z"] = ({
    tabs: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 8,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                title: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Title",
                    translatable: true
                },
                content: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Content",
                    textArea: true,
                    rows: 5,
                    translatable: true
                },
                timer: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Timer Length (in milliseconds)"
                },
                badgeText: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Badge text (if needed)",
                    translatable: true
                },
                asset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
                }
            }
        }
    },
    backgroundColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Background Color"
    },
    progressbarColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Progress Bar Color"
    },
    assetPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Asset Position",
        options: [
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.TOP_LEFT */ .b.TOP_LEFT,
                text: "Top Left"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.TOP_CENTER */ .b.TOP_CENTER,
                text: "Top Center"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.TOP_RIGHT */ .b.TOP_RIGHT,
                text: "Top Right"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.CENTER_LEFT */ .b.CENTER_LEFT,
                text: "Center Left"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.CENTER_CENTER */ .b.CENTER_CENTER,
                text: "Center Center"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.CENTER_RIGHT */ .b.CENTER_RIGHT,
                text: "Center Right"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.BOTTOM_LEFT */ .b.BOTTOM_LEFT,
                text: "Bottom Left"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.BOTTOM_CENTER */ .b.BOTTOM_CENTER,
                text: "Bottom Center"
            },
            {
                value: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_3__/* .positionTypes.BOTTOM_RIGHT */ .b.BOTTOM_RIGHT,
                text: "Bottom Right"
            }
        ]
    },
    showButton: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show Button"
    },
    isTabsFullWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Tabs full width"
    },
    buttonConfig: segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
});


/***/ }),

/***/ 25627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BADGES_PER_PRODUCT_BY_COUNTRY; },
/* harmony export */   "W": function() { return /* binding */ BADGES_COUNTRIES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84074);


/* BADGES */ var usersLoveUs = {
    name: "Users love us",
    url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/users-love-us_1_1.png"
};
var leaderMidMarketSpring23 = {
    name: "Leader mid-market spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/CRM_Leader_Mid-Market_Leader.png"
};
var leaderEnterpriseSpring23 = {
    name: "Leader enterprise spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/EmailTracking_Leader_Enterprise_Leader.png"
};
var leaderSmallBusinessSpring23 = {
    name: "Leader small business spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/SalesEnablement_Leader_Small-Business_Leader.png"
};
var leaderOfSpring23 = {
    name: "Leader spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/EmailTracking_Leader_Leader.png"
};
var momentumLeaderSpring23 = {
    name: "Momentum leader spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/SalesEnablement_MomentumLeader_Leader.png"
};
var top100FastestGrowingProduct = {
    name: "Top 100 fastest growing product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_6.png"
};
var top100HighestSatisfactionProduct = {
    name: "Top 100 highest satisfaction product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_5.png"
};
var top50SmallBusinessProduct = {
    name: "Top 50 small business product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_3.png"
};
var top100SoftwareProduct = {
    name: "Top 100 software product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_4.png"
};
var top50SalesProduct = {
    name: "Top 50 sales product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_2.png"
};
var crmUsersLoveAll = {
    name: "Users love us",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Group_2.png"
};
var bestUsabilitySmallBusinessSpring23 = {
    name: "Best usability small business spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/best_usability_small_spring23.png"
};
var leaderAnzSpring23 = {
    name: "Leader ANZ spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_ANZ_spring23.png"
};
var leaderAsiaPacificSpring23 = {
    name: "Leader Asia Pacific spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_asaia_pasific_spring23.png"
};
var leaderAsiaSpring23 = {
    name: "Leader Asia spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_Asia_spring23.png"
};
var highPerformerEnterpriseWinter2023 = {
    name: "High performer enterprise winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_HighPerformer_Enterprise_HighPerformer.png"
};
var leaderEuropeWinter2023 = {
    name: "Leader Europe winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Europe_Leader.png"
};
var leaderMidMarketWinter2023 = {
    name: "Leader mid-market winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Mid-Market_Leader.png"
};
var leaderSmallBusinessWinter2023 = {
    name: "Leader small business winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Small-Business_Leader.png"
};
var momentumLeaderWinter2023 = {
    name: "Momentum leader winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_MomentumLeader_Leader.png"
};
var bestUsabilitySmallBusinessWinter2023 = {
    name: "Best usability small business winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/SalesEnablement_BestUsability_Small-Business_Total.png"
};
var leaderEnterpriseWinter2023 = {
    name: "Leader enterprise winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/EmailTracking_Leader_Enterprise_Leader.png"
};
var leaderFall2024 = {
    name: "Leader fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182921/Generator_featured%20images/badges/Fall%202024/WorkManagement_Leader_Leader_1.png"
};
var leaderEnterpriseFall2024 = {
    name: "Leader enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/WorkManagement_Leader_Enterprise_Leader.png"
};
var usersMostLikelyToRecommendEnterpriseFall2024 = {
    name: "Users most likely to recommend enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/TaskManagement_UsersMostLikelyToRecommend_Enterprise_Nps_1.png"
};
var bestEstRoiEnterpriseFall2024 = {
    name: "Best estimated ROI enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/ProjectandPortfolioManagement_BestEstimatedROI_Enterprise_Roi_1.png"
};
var highestUserAdoptionEnterpriseFall2024 = {
    name: "Highest user adoption enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/EventPlanning_HighestUserAdoption_Enterprise_Adoption_1.png"
};
var fastestImplementationEnterpriseFall2024 = {
    name: "Fastest implementation enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/ProjectandPortfolioManagement_FastestImplementation_Enterprise_GoLiveTime_1.png"
};
var bestUsabilityFall2024 = {
    name: "Best usability fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/MarkupSoftware_BestUsability_Total_1.png"
};
var easiestAdminEnterpriseFall2024 = {
    name: "Easiest admin enterprise fall 2024",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1732182920/Generator_featured%20images/badges/Fall%202024/BusinessInstantMessaging_EasiestAdmin_Enterprise_EaseOfAdmin_1.png"
};
/* BADGES PER PRODUCT PER COUNTRY */ var BADGES_WORK_MANAGEMENT_GENRAL = [
    highestUserAdoptionEnterpriseFall2024,
    usersMostLikelyToRecommendEnterpriseFall2024,
    bestUsabilityFall2024,
    leaderFall2024,
    usersLoveUs,
    leaderEnterpriseFall2024,
    easiestAdminEnterpriseFall2024,
    fastestImplementationEnterpriseFall2024,
    bestEstRoiEnterpriseFall2024
];
var BADGES_CRM_GENERAL = [
    leaderMidMarketSpring23,
    leaderEnterpriseSpring23,
    leaderSmallBusinessSpring23,
    leaderOfSpring23,
    momentumLeaderSpring23,
    crmUsersLoveAll,
    top100FastestGrowingProduct,
    top100HighestSatisfactionProduct,
    top50SmallBusinessProduct,
    top100SoftwareProduct,
    top50SalesProduct
];
var BADGES_CRM_JAPAN = [
    leaderMidMarketSpring23,
    leaderEnterpriseSpring23,
    leaderSmallBusinessSpring23,
    leaderOfSpring23,
    momentumLeaderSpring23,
    crmUsersLoveAll,
    top50SalesProduct,
    bestUsabilitySmallBusinessSpring23,
    leaderAnzSpring23,
    leaderAsiaPacificSpring23,
    leaderAsiaSpring23
];
var BADGES_CRM_FRANCE = [
    top50SalesProduct,
    top100SoftwareProduct,
    bestUsabilitySmallBusinessWinter2023,
    highPerformerEnterpriseWinter2023,
    top100HighestSatisfactionProduct,
    crmUsersLoveAll,
    leaderMidMarketWinter2023,
    leaderSmallBusinessWinter2023,
    momentumLeaderWinter2023,
    leaderEuropeWinter2023,
    leaderEnterpriseWinter2023
];
/* EXPORTS */ var BADGES_COUNTRIES = {
    GENERAL: "General (default)",
    JAPAN: "Japan",
    FRANCE: "France"
};
var _obj, _obj1;
var BADGES_PER_PRODUCT_BY_COUNTRY = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_products__WEBPACK_IMPORTED_MODULE_0__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BADGES_COUNTRIES.GENERAL, BADGES_WORK_MANAGEMENT_GENRAL)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_products__WEBPACK_IMPORTED_MODULE_0__/* .CRM_PRODUCT_ID */ .$, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.GENERAL, BADGES_CRM_GENERAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.JAPAN, BADGES_CRM_JAPAN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.FRANCE, BADGES_CRM_FRANCE), _obj)), _obj1);


/***/ }),

/***/ 26455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84074);

/* harmony default export */ __webpack_exports__["Z"] = ({
    product: constants_products__WEBPACK_IMPORTED_MODULE_0__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py,
    horizontalPadding: "250px"
});


/***/ }),

/***/ 89138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ badges_grid; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/default-props.js
var default_props = __webpack_require__(26455);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-const.js
var badges_const = __webpack_require__(25627);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var badges_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Badges",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        product: {
            type: template_field_type.FIELD_TYPES.PRODUCTS,
            label: "Product"
        },
        country: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Country",
            options: badges_const/* BADGES_COUNTRIES */.W
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Horizontal padding",
            inputPlaceholder: default_props/* default.horizontalPadding */.Z.horizontalPadding
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-advanced-config.js
function badges_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function badges_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            badges_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var badges_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: badges_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/index.js



var BadgesGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(5365), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(1360), __webpack_require__.e(9112), __webpack_require__.e(9381)]).then(__webpack_require__.bind(__webpack_require__, 69737));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69737)
            ];
        }
    }
});
/* harmony default export */ var badges_grid = ({
    BadgesGridComponent: BadgesGridComponent,
    BadgesGridConfig: badges_grid_config,
    BadgesGridAdvancedConfig: badges_grid_advanced_config
});


/***/ }),

/***/ 73767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_grid_paragraph_with_image_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41667);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60633);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79409);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(constants_align_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13225);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24586);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(273);
/* harmony import */ var _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71021);

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var image = components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].image */ .Z.image;
var src = image.fields.src;
var mobileImage = _object_spread_props(_object_spread({}, image), {
    label: "Mobile image"
});
var backgroundImage = _object_spread_props(_object_spread({}, image), {
    label: "Card background image",
    fields: _object_spread_props(_object_spread({
        backgroundPosition: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Background position",
            options: [
                "left",
                "center",
                "right"
            ]
        }
    }, image.fields), {
        src: _object_spread_props(_object_spread({}, src), {
            getFullUrl: true
        })
    })
});
var backSideBackgroundImage = _object_spread_props(_object_spread({}, image), {
    label: "Card back side background image",
    fields: _object_spread_props(_object_spread({
        backgroundPosition: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Background position",
            options: [
                "left",
                "center",
                "right"
            ]
        }
    }, image.fields), {
        src: _object_spread_props(_object_spread({}, src), {
            getFullUrl: true
        })
    })
});
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Cards",
    fields: _object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
        borderColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                styles_color_consts__WEBPACK_IMPORTED_MODULE_9__.GAINSBORO_COLOR_NAME
            ])
        },
        shadowCards: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Add shadow to all cards"
        },
        removeShadowOnHover: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Remove shadow on hover"
        },
        gridAlignment: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Grid alignment",
            options: [
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.LEFT,
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.CENTER,
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.RIGHT
            ]
        },
        innerPadding: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Inner padding"
        },
        gridItems: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            nestedConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                fields: _object_spread_props(_object_spread({
                    cardColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Card color",
                        possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                            styles_color_consts__WEBPACK_IMPORTED_MODULE_9__.TRANSPARENT_COLOR_NAME
                        ])
                    },
                    backgroundImage: backgroundImage,
                    cardNumOfColumnsWidth: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Card width",
                        options: [
                            {
                                text: "25% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p, "px)"),
                                value: 1
                            },
                            {
                                text: "33% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 1.33 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 1.33
                            },
                            {
                                text: "33% - small version (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 1.2 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 1.2
                            },
                            {
                                text: "50% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 2 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 2
                            },
                            {
                                text: "66% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 2.66 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 2.66
                            },
                            {
                                text: "75% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 3 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K * 2, "px)"),
                                value: 3
                            },
                            {
                                text: "100% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 4 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K * 3, "px)"),
                                value: 4
                            }
                        ]
                    },
                    paragraphVerticalColoredLineColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Paragraph vertical colored line color",
                        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
                    }
                }, segments_desktop_core_components_grid_paragraph_with_image_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
                    mobileImage: mobileImage,
                    cardTagText: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Card tag text"
                    },
                    cardTagColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Card tag color",
                        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
                    },
                    addBackLayerContent: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                        label: "Add background content"
                    },
                    footer: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                        label: "Footer",
                        fields: {
                            showFooter: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                                label: "Show footer"
                            },
                            image: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                                label: "Footer image"
                            },
                            imageWidth: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                                label: "Footer image width"
                            },
                            text: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                                label: "Footer text",
                                textArea: true,
                                rows: 5
                            }
                        }
                    },
                    cardBackLayerContent: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                        label: "Card back layer content",
                        fields: {
                            contentVerticalAlignment: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                                label: "Content Vertical Alignment",
                                options: [
                                    "top",
                                    "center",
                                    "bottom"
                                ]
                            },
                            backSideBackgroundImage: backSideBackgroundImage,
                            backLayerFullParagraph: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                                label: "Full paragraph",
                                fields: _object_spread({}, segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)
                            }
                        }
                    }
                })
            }
        }
    })
});


/***/ }),

/***/ 84420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ flexible_cards_grid; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var flexible_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({
        cancelMobileMarginTop: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Cancel Mobile Margin Top"
        }
    }, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/index.js



var FlexibleCardsGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5365), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(1360), __webpack_require__.e(8885), __webpack_require__.e(2428)]).then(__webpack_require__.bind(__webpack_require__, 38885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38885)
            ];
        }
    }
});
/* harmony default export */ var flexible_cards_grid = ({
    FlexibleCardsGridComponent: FlexibleCardsGridComponent,
    FlexibleCardsGridConfig: flexible_cards_grid_config/* default */.Z,
    FlexibleCardsGridAdvancedConfig: flexible_cards_grid_advanced_config
});


/***/ }),

/***/ 92186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sliding_card_grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/fields-config.js
var fields_config = __webpack_require__(41667);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-config.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var backLayer = {
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Card back layer",
    conditionalKeyName: "enable",
    options: [
        {
            text: "True",
            fieldsConfig: fields_config/* default */.Z
        }
    ]
};
/* harmony default export */ var sliding_card_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sliding Card",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        cardsToShow: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Number of cards to show in view"
        },
        cardColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6).concat([
                "transparent"
            ])
        },
        carouselTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title with arrows",
            fields: _object_spread_props(_object_spread({}, title_fields_config/* default */.Z), {
                marginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin bottom"
                },
                withArrows: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "With arrows"
                }
            })
        },
        cardInnerPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card paragraph padding"
        },
        isFullScreen: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is full screen"
        },
        borderColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6).concat([
                "transparent"
            ])
        },
        arrowsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Arrows color"
        },
        backgroundHoverColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background hover color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6)
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Sliding Card",
                fields: _object_spread_props(_object_spread({}, fields_config/* default */.Z), {
                    backLayer: backLayer
                })
            }
        },
        autoplay: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Autoplay"
        },
        autoplaySpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Autoplay Speed"
        },
        infinite: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Infinite"
        },
        imageOnTop: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Card Image On Top"
        },
        arrowDesignType: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Arrow Design Type",
            options: [
                {
                    value: undefined,
                    text: "Arrows on bottom middle"
                },
                {
                    value: "arrows-on-top-right",
                    text: "Arrows on top right"
                }
            ]
        },
        arrowsTopOffset: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Arrows top offset"
        },
        topRightArrowColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Top right arrows color (icon and stroke)"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-advanced-config.js
function sliding_card_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var sliding_card_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sliding_card_grid_advanced_config_object_spread_props(sliding_card_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_theme_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        },
        desktopHorizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Desktop Horizontal Padding"
        },
        desktopHorizontalPaddingSmallScreens: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Desktop Horizontal Padding Small Screens"
        },
        desktopVerticalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Desktop vertical padding"
        },
        borderOpacity: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border opacity"
        },
        disableCardsHoverStyle: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable cards hover style"
        },
        focusOnSelect: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Focus on slide click (default is true)"
        },
        sideBySideImage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Side by side image"
        },
        reverseImageAndText: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Reverse image and text"
        },
        carouselTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Carousel Title Advanced Config",
            fields: sliding_card_grid_advanced_config_object_spread_props(sliding_card_grid_advanced_config_object_spread({}, advanced_field_config/* default */.Z), {
                arrowsAlignment: {
                    type: template_field_type.FIELD_TYPES.COMBO,
                    options: [
                        {
                            value: align_types.VERTICAL_ALIGN_LABELS.TOP,
                            text: align_types.VERTICAL_ALIGN_LABELS.TOP
                        },
                        {
                            value: align_types.VERTICAL_ALIGN_LABELS.CENTER,
                            text: align_types.VERTICAL_ALIGN_LABELS.CENTER
                        },
                        {
                            value: align_types.VERTICAL_ALIGN_LABELS.BOTTOM,
                            text: align_types.VERTICAL_ALIGN_LABELS.BOTTOM
                        }
                    ],
                    label: "Arrow Alignment"
                }
            })
        },
        removeArrows: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove arrows"
        },
        cardBorderRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card border radius (default 8px)"
        },
        cardImageSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card image size"
        },
        cardImageRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card image radius"
        },
        slideBreakingPoints: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Slide Breaking Points",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    breakpoint: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Breakpoint"
                    },
                    slidesToShow: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Cards to show"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/index.js



var SlidingCardGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5365), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(1360), __webpack_require__.e(9342), __webpack_require__.e(3416)]).then(__webpack_require__.bind(__webpack_require__, 47953));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47953)
            ];
        }
    }
});
/* harmony default export */ var sliding_card_grid = ({
    SlidingCardGridComponent: SlidingCardGridComponent,
    SlidingCardGridConfig: sliding_card_grid_config,
    SlidingCardGridAdvancedConfig: sliding_card_grid_advanced_config
});


/***/ }),

/***/ 80424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ monday_universe_homepage_first_fold; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/fields-config.js
var square_tags_fields_config = __webpack_require__(22333);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/palette-schemes.js
var palette_schemes = __webpack_require__(81122);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var textAlign = fields_config/* default.textAlign */.Z.textAlign, mobileTextAlign = fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textColor = fields_config/* default.textColor */.Z.textColor, topic = fields_config/* default.topic */.Z.topic, monday_universe_homepage_first_fold_config_button = fields_config/* default.buttonConfig */.Z.buttonConfig, restFullParagraphFieldsConfig = _object_without_properties(fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
var theme = square_tags_fields_config/* default.theme */.Z.theme, restSquareTagsFieldsConfig = _object_without_properties(square_tags_fields_config/* default */.Z, [
    "theme"
]);
/* harmony default export */ var monday_universe_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Universe",
    fields: _object_spread_props(_object_spread({
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
                segments_service/* BRAND_DARK_COLOR_THEME_ID */.qp,
                color_consts.CRM_DARKER_TINT_02,
                color_consts.BRAND_BLACK_BACKGROUND_COLOR,
                color_consts.WHITE_COLOR_NAME,
                color_consts.BRAND_DARK_COLOR,
                color_consts.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
                color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01
            ]
        },
        pallet: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Color Palette",
            options: [
                {
                    value: palette_schemes/* PALLET_VALUES.CRM_WHITE */.n.CRM_WHITE,
                    text: "CRM palette - for ".concat(color_consts.WHITE_COLOR_NAME, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.CRM_GREEN */.n.CRM_GREEN,
                    text: "CRM palette - for ".concat(color_consts.CRM_DARKER_TINT_02, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_WHITE */.n.DEV_WHITE,
                    text: "Dev palette - for ".concat(color_consts.WHITE_COLOR_NAME, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_BLACK */.n.DEV_BLACK,
                    text: "Dev palette - for ".concat(color_consts.BRAND_BLACK_BACKGROUND_COLOR, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_WHITE */.n.WM_WHITE,
                    text: "WM palette - for ".concat(color_consts.WHITE_COLOR_NAME, " / ").concat(color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_BLACK */.n.WM_BLACK,
                    text: "WM palette - for ".concat(color_consts.BRAND_BLACK_BACKGROUND_COLOR, " / ").concat(color_consts.BRAND_DARK_COLOR, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_PURPLE */.n.WM_PURPLE,
                    text: "WM palette - for ".concat(color_consts.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_OLD */.n.DEV_OLD,
                    text: "Dev palette - old for ".concat(color_consts.BRAND_DARK_COLOR, " background")
                }
            ]
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: restFullParagraphFieldsConfig
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        }
    }, restSquareTagsFieldsConfig), {
        lines: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Lines",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    start: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Start point",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    end: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "End point",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/advanced-fields-config.js
var square_tags_advanced_fields_config = __webpack_require__(73498);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-advanced-config.js
function monday_universe_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_universe_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_universe_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_universe_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_universe_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_universe_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, restOfParagraphAdvancedConfig = monday_universe_homepage_first_fold_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin"
]);
var topTriangle = shared_advanced_fields_config/* default.topTriangle */.ZP.topTriangle, bottomTriangle = shared_advanced_fields_config/* default.bottomTriangle */.ZP.bottomTriangle, restOfSharedFieldConfig = monday_universe_homepage_first_fold_advanced_config_object_without_properties(shared_advanced_fields_config/* default */.ZP, [
    "topTriangle",
    "bottomTriangle"
]);
/* harmony default export */ var monday_universe_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_universe_homepage_first_fold_advanced_config_object_spread({
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: restOfParagraphAdvancedConfig
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: advanced_field_config/* default */.Z
        },
        squareTagsMarginTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags margin top"
        }
    }, square_tags_advanced_fields_config/* default */.Z, restOfSharedFieldConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/index.js



var MondayUniverseHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(6416), __webpack_require__.e(7936)]).then(__webpack_require__.bind(__webpack_require__, 96515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96515)
            ];
        }
    }
});
/* harmony default export */ var monday_universe_homepage_first_fold = ({
    MondayUniverseHomepageFirstFoldComponent: MondayUniverseHomepageFirstFoldComponent,
    MondayUniverseHomepageFirstFoldConfig: monday_universe_homepage_first_fold_config,
    MondayUniverseHomepageFirstFoldAdvancedConfig: monday_universe_homepage_first_fold_advanced_config
});


/***/ }),

/***/ 81122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PALLET_VALUES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var PALLET_VALUES = {
    CRM_GREEN: "CRM_GREEN",
    DEV_BLACK: "DEV_BLACK",
    WM_PURPLE: "WM_PURPLE",
    CRM_WHITE: "CRM_WHITE",
    DEV_WHITE: "DEV_WHITE",
    WM_WHITE: "WM_WHITE",
    WM_BLACK: "WM_BLACK",
    DEV_OLD: "DEV_OLD"
};
var _obj;
/* harmony default export */ __webpack_exports__["Z"] = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.CRM_GREEN, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_BLACK, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_PURPLE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.CRM_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_LIGHTER_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARKER_TINT_02,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_LIGHTER_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_BLACK, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.UI_BORDER_LIGHT_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_OLD, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), _obj);


/***/ }),

/***/ 723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24586);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Full Paragraph",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedFullParagraphFields)
});


/***/ }),

/***/ 52514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ full_paragraph; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config.js
var full_paragraph_config = __webpack_require__(723);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var full_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z), {
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Wrapper max width"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/index.js

var FullParagraphComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(8461)]).then(__webpack_require__.bind(__webpack_require__, 98461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98461)
            ];
        }
    }
});


/* harmony default export */ var full_paragraph = ({
    FullParagraphComponent: FullParagraphComponent,
    FullParagraphConfig: full_paragraph_config/* default */.Z,
    FullParagraphAdvancedConfig: full_paragraph_advanced_config
});


/***/ }),

/***/ 29737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69223);
/* harmony import */ var segments_desktop_core_components_full_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47285);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, segments_desktop_core_components_full_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), {
        maxWidth: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Max Width"
        },
        removeBulletsMobileMarginTop: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Remove Bullets Margin Top On Mobile"
        }
    })
});


/***/ }),

/***/ 87313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24586);
/* harmony import */ var segments_desktop_core_components_bullets_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61204);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Full with bullets paragraph",
    fields: _object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedFullParagraphFields), {
        bulletsConfig: segments_desktop_core_components_bullets_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    })
});


/***/ }),

/***/ 16434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ side_by_side_tabs_and_process_tabs; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/fields-config.js



/* harmony default export */ var process_tabs_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: {
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        showProcessIndicator: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Process Indicator"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: fields_config/* default */.Z
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset Title",
                        fields: title_fields_config/* default */.Z
                    }
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-config.js
var vertical_timer_tabs_fields_config = __webpack_require__(32983);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var buttonConfig = vertical_timer_tabs_fields_config/* default.buttonConfig */.Z.buttonConfig, showButton = vertical_timer_tabs_fields_config/* default.showButton */.Z.showButton, progressbarColor = vertical_timer_tabs_fields_config/* default.progressbarColor */.Z.progressbarColor, backgroundColor = vertical_timer_tabs_fields_config/* default.backgroundColor */.Z.backgroundColor, _tabs = vertical_timer_tabs_fields_config/* default.tabs */.Z.tabs, _nestedConfig = _tabs.nestedConfig, timer = _nestedConfig.fields.timer, nestedTabsConfig = _object_without_properties(vertical_timer_tabs_fields_config/* default.tabs.nestedConfig.fields */.Z.tabs.nestedConfig.fields, [
    "timer"
]), tabsConfig = _object_without_properties(vertical_timer_tabs_fields_config/* default.tabs */.Z.tabs, [
    "nestedConfig"
]), rest = _object_without_properties(vertical_timer_tabs_fields_config/* default */.Z, [
    "buttonConfig",
    "showButton",
    "progressbarColor",
    "backgroundColor",
    "tabs"
]);
var textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, titleButtonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, title = full_paragraph_fields_config/* default.title */.Z.title, titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, topic = full_paragraph_fields_config/* default.topic */.Z.topic, resOfParagraphConfig = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "buttonConfig",
    "title",
    "titleColor",
    "textColor",
    "bodyColor",
    "topic"
]);
/* harmony default export */ var side_by_side_tabs_and_process_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Tabs And Process",
    fields: _object_spread(_object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        title: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: _object_spread_props(_object_spread({}, title_fields_config/* default */.Z), {
                titleMargin: {
                    label: "Title bottom margin",
                    type: template_field_type.FIELD_TYPES.TEXT
                }
            })
        },
        selectedTabBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Selected tab background color (for mobile)"
        },
        tabs: _object_spread({
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: _object_spread({
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    overrideTabFontColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Title Font Color"
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Full Paragraph",
                        fields: _object_spread_props(_object_spread({}, resOfParagraphConfig), {
                            buttonConfig: titleButtonConfig
                        })
                    },
                    processTab: process_tabs_fields_config
                }
            }, nestedTabsConfig)
        }, tabsConfig)
    }), rest)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config.js
var fields_advanced_config = __webpack_require__(74790);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-advanced-config.js
function side_by_side_tabs_and_process_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_process_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_tabs_and_process_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_tabs_and_process_tabs_advanced_config_object_spread(side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_process_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        title: {
            label: "Title",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: title_advanced_field_config/* default */.Z
        },
        advancedTitleConfig: side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_process_tabs_advanced_config_object_spread({}, fields_advanced_config/* default.title */.Z.title), {
            label: "Tab Title"
        }),
        tabContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: advanced_fields_config/* default */.Z
        },
        advancedProcessTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Process tabs",
            fields: {
                titleConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset Title",
                    fields: title_advanced_field_config/* default */.Z
                },
                autoTransition: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Auto Transition (milliseconds)"
                },
                scrollOnTabClick: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Should scroll to content on tab click"
                },
                scrollSpeed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Scroll speed on tab click"
                },
                distanceFromTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Distance to stop when scrolling (fixed header height)"
                }
            }
        },
        arrowSize: fields_advanced_config/* default.arrowSize */.Z.arrowSize
    }), advanced_field_config/* default */.Z)
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/index.js



var SideBySideTabsAndProcessTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5365), __webpack_require__.e(4069), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(1360), __webpack_require__.e(4864), __webpack_require__.e(9306), __webpack_require__.e(9526), __webpack_require__.e(2795), __webpack_require__.e(616)]).then(__webpack_require__.bind(__webpack_require__, 60616));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60616)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_tabs_and_process_tabs = ({
    SideBySideTabsAndProcessTabsComponent: SideBySideTabsAndProcessTabsComponent,
    SideBySideTabsAndProcessTabsConfig: side_by_side_tabs_and_process_tabs_config,
    SideBySideTabsAndProcessTabsAdvancedConfig: side_by_side_tabs_and_process_tabs_advanced_config
});


/***/ }),

/***/ 30788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ side_by_side_tabs_and_testimonial_tabs; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/testimonial/fields-config.js
var fields_config = __webpack_require__(61543);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-config.js
var vertical_timer_tabs_fields_config = __webpack_require__(32983);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var timerEnabled = vertical_timer_tabs_fields_config/* default.timerEnabled */.Z.timerEnabled, buttonConfig = vertical_timer_tabs_fields_config/* default.buttonConfig */.Z.buttonConfig, showButton = vertical_timer_tabs_fields_config/* default.showButton */.Z.showButton, progressbarColor = vertical_timer_tabs_fields_config/* default.progressbarColor */.Z.progressbarColor, backgroundColor = vertical_timer_tabs_fields_config/* default.backgroundColor */.Z.backgroundColor, _tabs = vertical_timer_tabs_fields_config/* default.tabs */.Z.tabs, _nestedConfig = _tabs.nestedConfig, timer = _nestedConfig.fields.timer, nestedTabsConfig = _object_without_properties(vertical_timer_tabs_fields_config/* default.tabs.nestedConfig.fields */.Z.tabs.nestedConfig.fields, [
    "timer"
]), tabsConfig = _object_without_properties(vertical_timer_tabs_fields_config/* default.tabs */.Z.tabs, [
    "nestedConfig"
]), rest = _object_without_properties(vertical_timer_tabs_fields_config/* default */.Z, [
    "timerEnabled",
    "buttonConfig",
    "showButton",
    "progressbarColor",
    "backgroundColor",
    "tabs"
]);
var _FullWithBulletsParagraphConfig_fields = full_with_bullets_paragraph_config/* default.fields */.Z.fields, textAlign = _FullWithBulletsParagraphConfig_fields.textAlign, mobileTextAlign = _FullWithBulletsParagraphConfig_fields.mobileTextAlign, title = _FullWithBulletsParagraphConfig_fields.title, titleColor = _FullWithBulletsParagraphConfig_fields.titleColor, textColor = _FullWithBulletsParagraphConfig_fields.textColor, bodyColor = _FullWithBulletsParagraphConfig_fields.bodyColor, topic = _FullWithBulletsParagraphConfig_fields.topic, restOfParagraphConfig = _object_without_properties(_FullWithBulletsParagraphConfig_fields, [
    "textAlign",
    "mobileTextAlign",
    "title",
    "titleColor",
    "textColor",
    "bodyColor",
    "topic"
]);
/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: _object_spread(_object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: title_fields_config/* default */.Z
        },
        tabs: _object_spread({
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: _object_spread({
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    overrideTabFontColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Title Font Color"
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Content",
                        fields: _object_spread({}, restOfParagraphConfig)
                    },
                    testimonial: fields_config/* default */.Z,
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: asset_fields_config/* default */.Z
                    }
                }
            }, nestedTabsConfig)
        }, tabsConfig)
    }), rest)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config.js
var fields_advanced_config = __webpack_require__(74790);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var asset_advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-advanced-config.js
function side_by_side_tabs_and_testimonial_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_testimonial_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_testimonial_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: advanced_field_config/* default */.Z
        },
        advancedTitleConfig: side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread({}, fields_advanced_config/* default.title */.Z.title), {
            label: "Tab Title"
        }),
        prerenderTabs: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Prerender tabs"
        },
        tabContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: full_with_bullets_paragraph_advanced_config/* default.fields */.Z.fields
        },
        arrowSize: fields_advanced_config/* default.arrowSize */.Z.arrowSize
    }), asset_advanced_field_config/* default */.Z)
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/index.js



var SideBySideTabsAndTestimonialTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(4069), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(4864), __webpack_require__.e(2466)]).then(__webpack_require__.bind(__webpack_require__, 44067));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44067)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs = ({
    SideBySideTabsAndTestimonialTabsComponent: SideBySideTabsAndTestimonialTabsComponent,
    SideBySideTabsAndTestimonialTabsConfig: side_by_side_tabs_and_testimonial_tabs_config,
    SideBySideTabsAndTestimonialTabsAdvancedConfig: side_by_side_tabs_and_testimonial_tabs_advanced_config
});


/***/ }),

/***/ 39750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ timeline_titled_tab_tabs; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/fields-config.js
var fields_config = __webpack_require__(92607);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var backgroundColor = fields_config/* default.backgroundColor */.Z.backgroundColor, theme = fields_config/* default.theme */.Z.theme, tabsColor = fields_config/* default.tabsColor */.Z.tabsColor, tabs = fields_config/* default.tabs */.Z.tabs, title = fields_config/* default.title */.Z.title, restOfConfig = _object_without_properties(fields_config/* default */.Z, [
    "backgroundColor",
    "theme",
    "tabsColor",
    "tabs",
    "title"
]);
var topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, body = full_paragraph_fields_config/* default.body */.Z.body, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, color = full_paragraph_fields_config/* default.color */.Z.color, restOfParagraphFields = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "textAlign",
    "body",
    "textColor",
    "titleColor",
    "color"
]);
/* harmony default export */ var timeline_titled_tab_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timeline",
    fields: _object_spread_props(_object_spread({
        theme: theme,
        tabsColor: tabsColor,
        titlesColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Titles Color"
        },
        lineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Menu line Color"
        }
    }, restOfConfig), {
        contentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content height (optional)"
        },
        contentGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content gap"
        },
        titles: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs Title",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabsTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tabs title"
                    },
                    tabs: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Tabs",
                        maxLimit: 8,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                tabLabel: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Tab Label",
                                    translatable: true
                                },
                                title: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    label: "Asset text",
                                    fields: restOfParagraphFields
                                },
                                asset: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    label: "Asset",
                                    fields: _object_spread({
                                        assetVerticalPadding: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Asset Vertical padding",
                                            translatable: true
                                        }
                                    }, asset_fields_config/* default */.Z)
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-advanced-config.js
function timeline_titled_tab_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_titled_tab_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_titled_tab_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_titled_tab_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timeline_titled_tab_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timeline_titled_tab_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var timeline_titled_tab_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timeline_titled_tab_tabs_advanced_config_object_spread_props(timeline_titled_tab_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        advancedAssetTitleConfig: {
            label: "Asset title",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: title_advanced_field_config/* default */.Z
        },
        tabAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Advanced Config",
            fields: {
                tabMaxWidth: {
                    label: "Tab title max width",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                tabLineHeight: {
                    label: "Tab title line height",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                tabHeight: {
                    label: "Tab height",
                    type: template_field_type.FIELD_TYPES.TEXT
                }
            }
        },
        advancedAssetConfig: {
            label: "Asset",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: advanced_field_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/index.js



var TimelineTitledTabTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(4837), __webpack_require__.e(9526), __webpack_require__.e(9964)]).then(__webpack_require__.bind(__webpack_require__, 19194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19194)
            ];
        }
    }
});
/* harmony default export */ var timeline_titled_tab_tabs = ({
    TimelineTitledTabTabsComponent: TimelineTitledTabTabsComponent,
    TimelineTitledTabTabsConfig: timeline_titled_tab_tabs_config,
    TimelineTitledTabTabsAdvancedConfig: timeline_titled_tab_tabs_advanced_config
});


/***/ }),

/***/ 94087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_cases_tabs; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var autoplay = carousel_fields_config/* default.autoplay */.Z.autoplay, autoplaySpeed = carousel_fields_config/* default.autoplaySpeed */.Z.autoplaySpeed;
var use_cases_tabs_config_image = asset_fields_config/* default.image */.Z.image; // videos will be supported in the future
/* harmony default export */ var use_cases_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Use Cases",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        buttonsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Buttons color",
            possibleColors: [
                color_consts.WHITE_COLOR_NAME,
                color_consts.CRM_DARK_TINT_01_COLOR_NAME,
                color_consts.CRM_DARKER_TINT_02_COLOR_NAME,
                color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME
            ]
        },
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        scrollWhenButtonClicked: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Scroll when a tab button is clicked"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 10,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Content",
                        fields: {
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: {
                                    image: use_cases_tabs_config_image
                                }
                            },
                            mobileAsset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Mobile asset",
                                fields: {
                                    image: use_cases_tabs_config_image
                                }
                            },
                            mobileTextAlign: {
                                type: template_field_type.FIELD_TYPES.COMBO,
                                label: "Paragraphs Mobile Text Align",
                                options: [
                                    {
                                        value: "left",
                                        text: "Left"
                                    },
                                    {
                                        value: "center",
                                        text: "Center"
                                    },
                                    {
                                        value: "right",
                                        text: "Right"
                                    }
                                ]
                            },
                            images: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Paragraphs",
                                maxLimit: 3,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        fullParagraph: {
                                            type: template_field_type.FIELD_TYPES.NESTED,
                                            label: "Full Paragraph",
                                            fields: _object_spread({}, fields_config/* default */.Z, paragraph_fields_config/* default */.Z)
                                        }
                                    }
                                }
                            },
                            banner: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Banner",
                                fields: {
                                    productType: {
                                        label: "Product",
                                        type: template_field_type.FIELD_TYPES.COMBO,
                                        options: products/* PRODUCT_OPTIONS */.ey
                                    },
                                    title: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Title",
                                        translatable: true
                                    },
                                    body: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Body",
                                        translatable: true
                                    },
                                    buttonText: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Button Text",
                                        translatable: true
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-advanced-config.js
function use_cases_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function use_cases_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            use_cases_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var use_cases_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: use_cases_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/index.js



var UseCasesTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5365), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(1360), __webpack_require__.e(9306), __webpack_require__.e(2795), __webpack_require__.e(5512)]).then(__webpack_require__.bind(__webpack_require__, 93012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93012)
            ];
        }
    }
});
/* harmony default export */ var use_cases_tabs = ({
    UseCasesTabsComponent: UseCasesTabsComponent,
    UseCasesTabsConfig: use_cases_tabs_config,
    UseCasesTabsAdvancedConfig: use_cases_tabs_advanced_config
});


/***/ }),

/***/ 74793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ full_background_text_and_asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/fields-config.js
var fields_config = __webpack_require__(55782);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var full_background_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Background",
    fields: _object_spread({
        paragraphVerticalAlignment: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Paragraph Vertical Alignment",
            options: [
                "top",
                "center",
                "bottom"
            ]
        }
    }, theme_config/* default */.Z, fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-advanced-config.js
function full_background_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_background_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_background_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_background_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: full_background_text_and_asset_advanced_config_object_spread(_object_spread_props(full_background_text_and_asset_advanced_config_object_spread({
        height: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Height"
        }
    }, shared_advanced_fields_config/* default */.ZP), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/index.js

var FullBackgroundTextAndAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(4925)]).then(__webpack_require__.bind(__webpack_require__, 54925));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54925)
            ];
        }
    }
});


/* harmony default export */ var full_background_text_and_asset = ({
    FullBackgroundTextAndAssetComponent: FullBackgroundTextAndAssetComponent,
    FullBackgroundTextAndAssetConfig: full_background_text_and_asset_config,
    FullBackgroundTextAndAssetAdvancedConfig: full_background_text_and_asset_advanced_config
});


/***/ }),

/***/ 25514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ side_by_side_text_and_asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var background = fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side",
    fields: _object_spread({}, theme_config/* default */.Z, selectedSideBySideTextAndAssetFieldsConfig)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var side_by_side_text_and_asset_advanced_field_config = __webpack_require__(77374);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-advanced-config.js
function side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z, side_by_side_text_and_asset_advanced_field_config/* default */.Z), {
        nestedBoardItems: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Embedded Board",
            fields: {
                addLiveBoardTextAndAsset: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add Live Board Experience"
                },
                boardBannerText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Board Banner Text",
                    translatable: true
                },
                embeddedBoardTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Embedded Board Title",
                    translatable: true
                },
                addSecondLiveBoardSignUpButton: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add Second Sign Up Button In The Live Board"
                },
                liveBoardToolTipText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Live Board Tooltip Text"
                },
                parallaxAsset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Parallax Asset- IN TEST - DON'T USE",
                    fields: side_by_side_text_and_asset_advanced_config_object_spread({
                        position: {
                            type: template_field_type.FIELD_TYPES.COMBO,
                            label: "Position",
                            options: [
                                "top",
                                "center",
                                "bottom"
                            ]
                        },
                        fitToContainer: {
                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                            label: "Fit to container"
                        }
                    }, asset_fields_config/* default */.Z)
                },
                gapBetweenAssets: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Gap Between Assets(px)"
                },
                fullParagraphMarginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Top"
                },
                fullParagraphMarginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Bottom"
                },
                fullParagraphDistanceFromTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Distance From Top When Parallax"
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/index.js

var SideBySideTextAndAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7229), __webpack_require__.e(6602), __webpack_require__.e(390), __webpack_require__.e(8834), __webpack_require__.e(5657), __webpack_require__.e(4494), __webpack_require__.e(4961), __webpack_require__.e(6430), __webpack_require__.e(3211), __webpack_require__.e(9526), __webpack_require__.e(7763)]).then(__webpack_require__.bind(__webpack_require__, 8150));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8150)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_text_and_asset = ({
    SideBySideTextAndAssetComponent: SideBySideTextAndAssetComponent,
    SideBySideTextAndAssetConfig: side_by_side_text_and_asset_config,
    SideBySideTextAndAssetAdvancedConfig: side_by_side_text_and_asset_advanced_config
});


/***/ }),

/***/ 34949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ fetchDynamicSegmentsRequestFromClient; },
/* harmony export */   "Fb": function() { return /* binding */ getDynamicPropsBySegmentLayoutId; }
/* harmony export */ });
/* unused harmony exports fetchDynamicSegmentsRequestFromServer, getFaqData */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);
/* harmony import */ var _server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24730);
/* harmony import */ var _server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var fetchAllRequestsAndPopulateDynamicData = function() {
    var _ref = _async_to_generator(function(param) {
        var segmentsRequest, dynamicData, hasUpdated;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    segmentsRequest = param.segmentsRequest, dynamicData = param.dynamicData;
                    hasUpdated = false;
                    return [
                        4,
                        Promise.all(segmentsRequest)
                    ];
                case 1:
                    _state.sent().forEach(function(param) {
                        var id = param.id, fetchRes = param.fetchRes, error = param.error, propsPropertyName = param.propsPropertyName;
                        if (!error) {
                            hasUpdated = true;
                            dynamicData[id] = _object_spread_props(_object_spread({}, dynamicData[id] || {}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, propsPropertyName, fetchRes));
                        }
                    });
                    return [
                        2,
                        hasUpdated
                    ];
            }
        });
    });
    return function fetchAllRequestsAndPopulateDynamicData(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllAvailableDynamicRequestsData = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper;
    var requests = (pageConfig.segments || []).reduce(function(accRequests, segment) {
        var segmentLayoutType = segment.type, segmentLayoutProps = segment.props, segmentLayoutId = segment.id;
        var dynamicFetchRequests = segmentsDynamicsFetchMapper[segmentLayoutType];
        if (dynamicFetchRequests) {
            dynamicFetchRequests.forEach(function(fetchRequest) {
                var shouldFetch = fetchRequest.shouldFetch, fetch = fetchRequest.fetch, propsPropertyName = fetchRequest.propsPropertyName;
                accRequests.push({
                    shouldFetch: shouldFetch,
                    fetch: fetch,
                    propsPropertyName: propsPropertyName,
                    segmentLayoutProps: segmentLayoutProps,
                    segmentLayoutId: segmentLayoutId,
                    segmentLayoutType: segmentLayoutType
                });
            });
        }
        ;
        return accRequests;
    }, []);
    return requests;
};
var collectAllRequestsForClient = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, previousPageConfig = param.previousPageConfig;
    var previousPropsBySegmentIds = (previousPageConfig.segments || []).reduce(function(acc, param) {
        var id = param.id, props = param.props;
        acc[id] = props;
        return acc;
    }, {});
    var allRequests = getAllAvailableDynamicRequestsData({
        pageConfig: pageConfig,
        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper
    });
    var segmentsRequest = allRequests.reduce(function(accRequests, request) {
        var shouldFetch = request.shouldFetch, fetch = request.fetch, propsPropertyName = request.propsPropertyName, segmentLayoutProps = request.segmentLayoutProps, segmentLayoutId = request.segmentLayoutId;
        if (shouldFetch({
            props: segmentLayoutProps,
            previousProps: previousPropsBySegmentIds[segmentLayoutId] || {},
            pageConfig: pageConfig,
            previousPageConfig: previousPageConfig
        })) {
            accRequests.push(_async_to_generator(function() {
                var fetchRes, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                fetch({
                                    props: segmentLayoutProps,
                                    pageConfig: pageConfig,
                                    isClientFetch: true
                                })
                            ];
                        case 1:
                            fetchRes = _state.sent();
                            return [
                                2,
                                {
                                    id: segmentLayoutId,
                                    fetchRes: fetchRes,
                                    propsPropertyName: propsPropertyName
                                }
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                2,
                                {
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })());
        }
        return accRequests;
    }, []);
    return segmentsRequest;
};
var collectAllRequestsForServer = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, req = param.req, res = param.res, query = param.query;
    var allRequests = getAllAvailableDynamicRequestsData({
        pageConfig: pageConfig,
        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper
    });
    var segmentsRequest = allRequests.reduce(function(accRequests, request) {
        var fetch = request.fetch, propsPropertyName = request.propsPropertyName, segmentLayoutProps = request.segmentLayoutProps, segmentLayoutId = request.segmentLayoutId, segmentLayoutType = request.segmentLayoutType;
        accRequests.push(_async_to_generator(function() {
            var fetchRes, error, extraLogParams;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch({
                                props: segmentLayoutProps,
                                pageConfig: pageConfig,
                                isClientFetch: false,
                                query: query
                            })
                        ];
                    case 1:
                        fetchRes = _state.sent();
                        return [
                            2,
                            {
                                id: segmentLayoutId,
                                fetchRes: fetchRes,
                                propsPropertyName: propsPropertyName
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        extraLogParams = {
                            segmentLayoutType: segmentLayoutType,
                            segmentLayoutId: segmentLayoutId,
                            fetchProperty: propsPropertyName
                        };
                        (0,_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__.handleServerException)({
                            externalMessage: "Faild to fetch dynamic data on template generator",
                            e: error,
                            req: req,
                            res: res,
                            extraLogParams: extraLogParams
                        });
                        return [
                            2,
                            {
                                error: error
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })());
        return accRequests;
    }, []);
    return segmentsRequest;
};
var fetchDynamicSegmentsRequestFromServer = function() {
    var _ref = _async_to_generator(function(param) {
        var _pageConfig, pageConfig, segmentsDynamicsFetchMapper, req, res, query, dynamicData, segmentsRequest, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageConfig = param.pageConfig, pageConfig = _pageConfig === void 0 ? {} : _pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, req = param.req, res = param.res, query = param.query;
                    dynamicData = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    segmentsRequest = collectAllRequestsForServer({
                        pageConfig: pageConfig,
                        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper,
                        req: req,
                        res: res,
                        query: query
                    });
                    return [
                        4,
                        fetchAllRequestsAndPopulateDynamicData({
                            segmentsRequest: segmentsRequest,
                            dynamicData: dynamicData
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    (0,_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__.handleServerException)({
                        externalMessage: "Fatal error: Faild in the proccess of fetching dynamic data on template generator",
                        e: error,
                        req: req,
                        res: res,
                        query: query
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        {
                            dynamicData: dynamicData
                        }
                    ];
            }
        });
    });
    return function fetchDynamicSegmentsRequestFromServer(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDynamicSegmentsRequestFromClient = function() {
    var _ref = _async_to_generator(function(param) {
        var _pageConfig, pageConfig, _previousPageConfig, previousPageConfig, segmentsDynamicsFetchMapper, _previousDynamicData, previousDynamicData, dynamicData, segmentsRequest, hasUpdated;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageConfig = param.pageConfig, pageConfig = _pageConfig === void 0 ? {} : _pageConfig, _previousPageConfig = param.previousPageConfig, previousPageConfig = _previousPageConfig === void 0 ? {} : _previousPageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, _previousDynamicData = param.previousDynamicData, previousDynamicData = _previousDynamicData === void 0 ? {} : _previousDynamicData;
                    dynamicData = _object_spread({}, previousDynamicData);
                    segmentsRequest = collectAllRequestsForClient({
                        pageConfig: pageConfig,
                        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper,
                        previousPageConfig: previousPageConfig
                    });
                    return [
                        4,
                        fetchAllRequestsAndPopulateDynamicData({
                            segmentsRequest: segmentsRequest,
                            dynamicData: dynamicData
                        })
                    ];
                case 1:
                    hasUpdated = _state.sent();
                    return [
                        2,
                        {
                            hasUpdated: hasUpdated,
                            dynamicData: dynamicData
                        }
                    ];
            }
        });
    });
    return function fetchDynamicSegmentsRequestFromClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDynamicPropsBySegmentLayoutId = function(dynamicData, id) {
    return dynamicData && dynamicData[id] || {};
};
var getFaqData = function(param) {
    var pageConfig = param.pageConfig, req = param.req, res = param.res;
    var faq = [];
    try {
        faq = (pageConfig.segments || []).reduce(function(accFaq, segment) {
            var type = segment.type, props = segment.props;
            if (type === "FrequentlyAskedQuestionsPricingComponent") {
                var _accFaq;
                (_accFaq = accFaq).push.apply(_accFaq, _to_consumable_array(props.questions));
            }
            return accFaq;
        }, []);
    } catch (error) {
        handleServerException({
            externalMessage: "Faild to get FAQ data from segments",
            e: error,
            req: req,
            res: res
        });
    }
    return faq;
};


/***/ }),

/***/ 70942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MH": function() { return /* binding */ randomNumber; },
/* harmony export */   "Yr": function() { return /* binding */ toRadians; },
/* harmony export */   "sI": function() { return /* binding */ lineDistance; }
/* harmony export */ });
var toRadians = function(angle) {
    return angle * (Math.PI / 180);
};
var lineDistance = function(x1, y1, x2, y2) {
    var a = x1 - x2;
    var b = y1 - y2;
    var distance = Math.sqrt(a * a + b * b);
    return distance;
};
var randomNumber = function(min, max) {
    return Math.random() * (max - min) + min;
};


/***/ })

}]);